// Polyfill
import '@babel/polyfill'

import '../assets'

import Vue from 'vue'
// import VueBootstrapper from 'vue-bootstrapper'
import Homepage from '@components/homepage'


//import store from '@store'

// Vue.use(VueBootstrapper)

const vueInstance = new Vue({
  el: '#home-root',
  data () {
    return {
      // windowWidth: 0,
      // windowHeight: 0,
      // routes: [],
    }
  },
  components:{
    Homepage
  },
  created () {
  },
  props: {
  },
  mounted () {
    var me = this;
    window.addEventListener('changeTab', function ({ detail }) {
      if(detail.currentTabSlug.indexOf('initiative') >= 0){
        setTimeout(()=>{
          if(me.$refs.homepageCmp.$refs.storiesGallery){
            me.$refs.homepageCmp.$refs.storiesGallery.$refs.flickity.resize()
          }
        }, 1)
        setTimeout(()=>{
          if(me.$refs.homepageCmp.$refs.randomSliderDesktop){
            me.$refs.homepageCmp.$refs.randomSliderDesktop.$refs.flickity.resize()
          }
        }, 1)
        setTimeout(()=>{
          if(me.$refs.homepageCmp.$refs.newsGallery){
            me.$refs.homepageCmp.$refs.newsGallery.$refs.flickity.resize()
          }
        }, 1)
      }
    })
  },
  methods: {
  },
})

window.vueInstance = vueInstance

